<script>
  import { _ } from "./i18n.js";
  import { onMount, onDestroy } from "svelte";
  import {
    f7,
    BlockTitle,
    List,
    ListItem,
    Button,
    Preloader,
    SwipeoutActions,
    SwipeoutButton
  } from "framework7-svelte";
  import { getProfile } from "./UserService.js";
  import { getSecuredFirestore } from "./Firestore.js";
  import moment from "moment";

  export let f7router;
  export let f7route;

  let userId = f7route.params.id;
  let orders;
  let myOrders = f7route.path.endsWith("My");
  let swipingout;

  let admin;
  getProfile().then(function(profile) {
    admin = profile.admin === true;
  });

  function init() {
    if (userId) {
      load(userId);
    } else {
      getProfile().then(function(profile) {
        load(profile.userId);
      });
    }
  }
  onMount(async () => {
    init();
  });

  let snapshotlistener;
  onDestroy(async () => {
    snapshotlistener && snapshotlistener();
  });

  function load(userId) {
    getSecuredFirestore().then(function(firestore) {
      let usersRef = firestore.collection("users");
      let userDoc = usersRef.doc(userId);

      let orderRef = firestore.collection("orders");
      let orderQuery = orderRef
        .where("userRef", "==", userDoc)
        .orderBy("created", "desc");
      snapshotlistener = orderQuery.onSnapshot(
        function(querySnapshot) {
          orders = querySnapshot.docs;
        },
        function(err) {
          console.log(err);
          orders = -1;
          f7.dialog.alert($_("order.errorLoading"));
        }
      );
    });
  }
</script>

<div>
  {#if !orders}
    <div
      style="align-items: center; display: flex; justify-content: center;
      flex-direction: column; height: 100%;">

      <Preloader />
    </div>
  {:else if orders == -1}
    <div
      style="align-items: center; display: flex; justify-content: center;
      flex-direction: column; height: 100%;">

      <Button fill round large on:click={() => ((orders = null), init())}>
        {$_('order.reload')}
        <span style="margin-left: 8px" class="icon icon-loop" />
      </Button>
    </div>
  {:else if orders && orders.length == 0}
    <div
      style="align-items: center; display: flex; justify-content: center;
      flex-direction: column; height: 100%;">

      <BlockTitle medium style="margin-top: 40px">
        {#if myOrders}
          {$_('orderAll.me.noOrders')}
        {:else}{$_('orderAll.noOrders')}{/if}

      </BlockTitle>

      <img
        style="width: 100%; max-width: 500px"
        alt="No Orders"
        src="https://lh3.googleusercontent.com/pw/ACtC-3dbtnZpZFfsc-l6kU7MB_JvFy1L-ffcBkcLCWkIus3y6FvSAFGbAvLC706OHEYXWd00qsW0C7Ju_tDufk4DMqCXfRTNUssRVFaCqI1-RRDwRYiMviGDeNEm6RZz7UijkfN3iVBKkfxN_nHtkc7bQgdHuQ=s800" />

      {#if myOrders}
        <div style="width: 100%;">
          <Button
            style="margin: 20px"
            color="green"
            fill
            round
            href="/Products/">
            {$_('orderAll.try')}
            <span
              style="margin-left: 4px; vertical-align: text-top"
              class="icon icon-winner" />
          </Button>
        </div>
      {/if}
    </div>
  {:else if orders && orders.length > 0}
    <List style="margin-top: 0px">
      {#each orders as order}
        <ListItem
          swipeout={admin}
          on:swipeoutOpen={e => {
            swipingout = true;
          }}
          on:swipeoutClosed={e => {
            swipingout = false;
          }}
          on:click={e => {
            if (!swipingout) {
              f7router.navigate('/Order/' + order.id);
            }
          }}
          header={$_('orderAll.pack', {
            values: {
              n: order
                .get('items')
                .reduce((total, item) => total + item.amount, 0)
            }
          })}
          title={moment(order
              .get('created')
              .toDate()).format('Do MMMM YYYY, h:mm A')}>

          <SwipeoutActions right>
            <SwipeoutButton
              color="red"
              on:click={function(e) {
                let id = order.id;
                f7.dialog.confirm($_('order.deleteOrder.confirm'), () => {
                  f7.swipeout.close(f7.swipeout.el, function() {
                    let dialog = f7.dialog.preloader($_('order.deleting'));
                    getSecuredFirestore().then(function(firestore) {
                      let orderRef = firestore
                        .collection('orders')
                        .doc(id)
                        .delete()
                        .then(async function() {
                          dialog.close();
                          f7.toast
                            .create({
                              text: $_('order.delete.success'),
                              closeTimeout: 6000
                            })
                            .open();
                        })
                        .catch(function(e) {
                          console.log(e);
                          dialog.close();
                          f7.dialog.alert($_('order.delete.error'));
                        });
                    });
                  });
                });
              }}>
              {$_('base.delete')}
            </SwipeoutButton>
          </SwipeoutActions>

          <span slot="content-start">
            {#if order.get('status') === 'Pending'}
              <span
                style="margin-right: 10px; color: red"
                class="icon icon-pending" />
            {:else}
              <span
                style="margin-right: 10px; color: green"
                class="icon icon-deliverable" />
            {/if}
          </span>
        </ListItem>
      {/each}
    </List>
  {/if}
</div>
